import { render } from "./WaveAnimation.vue?vue&type=template&id=16ff7648&scoped=true"
import script from "./WaveAnimation.vue?vue&type=script&lang=js"
export * from "./WaveAnimation.vue?vue&type=script&lang=js"

import "./WaveAnimation.vue?vue&type=style&index=0&id=16ff7648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ff7648"]])

export default __exports__